module.exports = __webpack_public_path__ + "fonts/GothamSSm-Light_Web.9549abd.woff";